import { Alert, Slide, Snackbar } from "@mui/material";
import React, { createContext, useContext, useState } from "react";

const ToasterContext = createContext();

export const ToasterProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  const addToaster = ({ message, severity }) => {
    setMessage(`${message}`);
    setSeverity(severity);
    setOpen(true);
  };

  const handleClose = async () => setTimeout(() => setOpen(false), 360);

  return (
    <ToasterContext.Provider value={{ addToaster, open }}>
      {open && (
        <Snackbar
          open={open}
          autoHideDuration={3600}
          onClose={handleClose}
          TransitionComponent={Slide}
          TransitionProps={{ direction: "left" }}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          ClickAwayListenerProps={{ onClickAway: () => {} }}
          disableWindowBlurListener
        >
          <Alert severity={severity}>{message}</Alert>
        </Snackbar>
      )}
      {children}
    </ToasterContext.Provider>
  );
};

export default function useToaster() {
  const { addToaster, open } = useContext(ToasterContext);
  return { addToaster, open };
}
